import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"margin-top":"-10rem"},
  class: "w-100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Images")
], -1)
const _hoisted_3 = { class: "fv-row mb-10 d-flex flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Logo", -1)
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_7 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "Allowed file types: png, jpg, jpeg.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            style: _normalizeStyle([{"background-size":"contain","background-position-y":"center","background-position-x":"center"}, `background-image: ${`url(${
              _ctx.formData?.logo ?? _ctx.tempImageLogo
            })`}`]),
            ref: "profilePictureRef",
            class: "image-input-wrapper w-250px h-250px"
          }, null, 4),
          _createElementVNode("label", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("input", {
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleImageUpload($event))),
              type: "file",
              name: "logo",
              accept: ".png, .jpg, .jpeg"
            }, null, 32),
            _hoisted_9
          ])
        ]),
        _hoisted_10
      ])
    ])
  ]))
}